export default "__VITE_ASSET__DaffhFfB__"